<button mat-flat-button color="{{ theme }}" id="{{ id }}">
  <div
    [ngClass]="{
      single_column: !(buttonText && iconUrl) && (buttonText || iconUrl)
    }"
  >
    @if (iconUrl) {
    <svg-icon src="{{ iconUrl }}" [svgStyle]="{ 'width.px': 16, 'height.px': 16 }" [class]="'icon'"></svg-icon>
    } @if (buttonText) {
    <span [ngClass]="{ noIcon: iconUrl && buttonText }">
      {{ buttonText }}
    </span>
    }
  </div>
</button>
